import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'
import styles from './index.module.scss'

export const Input: FunctionalComponent<{
  disabled?: boolean
  placeholder?: string
  autoFocus?: boolean
  value?: string
  onChange?: (value: string) => void
}> = props => {
  const [focus, setFocus] = useState(false)

  return (
    <div
      class={classNames(styles.root, {
        [styles.focus]: focus,
      })}
    >
      <input
        type='text'
        disabled={props.disabled}
        class={styles.input}
        placeholder={props.placeholder}
        value={props.value ?? ''}
        onInput={e => {
          props.onChange?.(e.currentTarget.value)
        }}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
      />
    </div>
  )
}
